import { Component } from '@angular/core';
import {NavController, NavParams, ToastController, ModalController, AlertController} from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { BackgroundMode } from '@ionic-native/background-mode';
import { LocalNotifications } from '@ionic-native/local-notifications';
import {MainPage} from "../main/main";
import {UtilsService} from "../../services/utils.service";
import {AssetsService} from "../../services/assets.service";
import {SensorUtilService} from "../../services/sensors.service";
import {LoginPage} from "../login/login";
import {AuthService} from "../../services/auth.service";
import {SocketService} from "../../services/socket.service";
import {FleetsService} from "../../services/fleets.service";
import {DriversService} from "../../services/drivers.service";
import {CompaniesModal} from "../modals/companies/companies.modal";
import {FleetsModal} from "../modals/fleets/fleets.modal";
import {RealtimeMultiPage} from "../realtime/realtime.multi";
import {noUndefined} from "@angular/compiler/src/util";

@Component({
  selector: 'page-assets',
  templateUrl: 'assets.html',

})
export class AssetsPage{

  private assets: any = [];
  private companies: any = [];
  private fleets: any = [];
  private ids: any = [];
  private filteredAssets :any = [];
  private search : string = '';


  private displaySearch: boolean = false;

  private selectedCompany: any;
  private selectedFleet: any;
private onlyAssets=false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private alertCtrl: AlertController,
              public modalCtrl: ModalController,
              private utilsService : UtilsService,
              private socketService : SocketService,
              private assetsService : AssetsService,
              private sensorUtilService : SensorUtilService,
              private authService: AuthService,
              private driversService: DriversService,
              private fleetService: FleetsService,
              public storage: Storage,
              public localNotifications: LocalNotifications,
              private backgroundMode: BackgroundMode,
              private toastCtrl: ToastController) {

    //If data are preloaded
    this.assets = navParams.get('assets');
    this.companies = navParams.get('companies');
    this.fleets = navParams.get('fleets');
    this.ids = navParams.get('ids');
    this.storage.get('username')
    if(this.search =='') this.filteredAssets = this.filterAsset();
 /*   if(this.companies.length === 1 && this.fleets.length === 1 && this.assets.length === 1){
    this.navCtrl.setRoot(MainPage, {asset: this.assets[0], canGoBack: false})
    }*/


    this.rtUpdate();

    //else show loader and load data
  }

  filterAsset(){
    if(this.assets){
      this.filteredAssets = this.filterItems();

    }


  }

  filterItems(){

    return this.assets.filter((asset) => {
      return asset.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
    });

  }

  ionViewDidLoad() {
    this.filterAsset();
  }

  toggleSearch(){
    this.displaySearch = !this.displaySearch;
  }

  companiesModal() {
   let companiesModal = this.modalCtrl.create(CompaniesModal, {companies : this.companies});
   companiesModal.onDidDismiss(data=>{
     this.search = '';
     this.displaySearch = false;

     if(data){
       this.selectedCompany = data;
       this.loadFleets();
     }
   });
   companiesModal.present();
  }

  showFleets() {
    let fleetModal = this.modalCtrl.create(FleetsModal, {fleets : this.fleets});
    fleetModal.onDidDismiss(data=>{
      this.search = '';
      this.displaySearch = false;

      if(data){
        this.selectedFleet = data;
        this.loadAssets();
      }
    });
    fleetModal.present();
  }


  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }

  ngOnInit() {
    
    this.selectedCompany = this.companies[0];
    this.selectedFleet = this.fleets[0];


  }

  loadAddress(){
    let coordinates = [];
    let result = [];
    for(let asset of this.assets) {
      if (asset.rt && asset.rt.loc && asset.rt.loc.coordinates && asset.rt.loc.coordinates[1] && asset.rt.loc.coordinates[0]) {
        coordinates.push([asset.rt.loc.coordinates[0], asset.rt.loc.coordinates[1]])
      } else {
        coordinates.push([0, 0])

      }
    }

    if (coordinates.length > 0){
      this.utilsService.getAddress(coordinates).subscribe(data => {
        let res = data.BND.BatchResults;

        if (res.length > 0) {
          for(let value of res){
            if (value.Elements.count > 0) {
              let element = value.Elements.Element[0];
              let address = this.utilsService.format(element);
              result.push(address);
            }
            else
              result.push("Not available")
          }
        }


        let i = 0;
        for(let asset of this.assets) {
          if (asset.rt && asset.rt.loc && asset.rt.loc.coordinates && asset.rt.loc.coordinates[1] && asset.rt.loc.coordinates[1] !== 0 && asset.rt.loc.coordinates[0] && asset.rt.loc.coordinates[0] !== 0)
            asset.address = result[i];
          i++;
          this.getAssetSensors(asset);
        }
      });
    }
  }

  getAssetSensors(asset){
    let sensors = asset.sensors;
    asset.sensorData = [];
    if(sensors.length > 0){
      for(let sensor of sensors){
        let sensorName = sensor.name;
        let src = sensor.src.slice(sensor.src.lastIndexOf('.') + 1);
        if (sensor.type && sensor.src && Number.isFinite(asset.rt.io[src])) {
          let realVal = asset.rt.io[src];
          if (this.sensorUtilService.getSensorFamily(sensor.type) === "ANALOGIC") {
            if (Number.isFinite(sensor.minSrc) && Number.isFinite(sensor.maxSrc) && Number.isFinite(sensor.min) && Number.isFinite(sensor.max)) {
              realVal = this.sensorUtilService.getRealSensorValue(asset.rt.io[src], sensor.minSrc, sensor.maxSrc, sensor.min, sensor.max, sensor.gaps, sensor);
            }
            if(sensor.type == "FUEL_LEVEL")
            sensor.value_pourcent =
                        (realVal / sensor.max) * 100;
                     
                        if (Number.isFinite(realVal))
                          asset.sensorData.push({
                            name: sensorName,
                            type: sensor.type,
                            family: sensor.family,
                            unit: sensor.unit,
                            value: parseFloat(realVal.toFixed(2)),
                            max: sensor.max,
                            min: sensor.min,
                            maxSrc: sensor.maxSrc,
                            minSrc: sensor.minSrc,
                            value_pourcent:sensor.value_pourcent ? parseFloat(sensor.value_pourcent.toFixed(2)) :null
                          });
          }
          if (this.sensorUtilService.getSensorFamily(sensor.type) === "BINARY") {

            asset.sensorData.push({
              name: sensorName,
              type: sensor.type,
              family: sensor.family,
              ON: sensor.ON,
              OFF: sensor.OFF,
              value:realVal,
              status: realVal === sensor.ON ? this.sensorUtilService.getSensorsTypes().STATUS[sensor.type].enabled
              :  this.sensorUtilService.getSensorsTypes().STATUS[sensor.type].disabled,
              class: realVal === sensor.ON ? "is-on" : "is-off"
            });
          }
        }
      }
    }
    if(this.search =='')  this.filteredAssets = this.assets;
  }

  rtUpdate(){

    /**
     * Realtime
     */
    this.storage.ready().then(()=>{
      this.storage.get('user').then(user=>{
        this.socketService.connect(user);
        this.socketService.on('newMsg').subscribe((data: any)=>{
          if(this.assets){
       
            for(let asset of this.assets){
              if(asset._id === data._id){
                let index = this.assets.indexOf(asset);
                data.type = asset.type
                data = this.assetsService.getSingleAssetIcons(data);
                this.getAssetSensors(data);
                this.assets[index] = data;
                this.loadAddress();
                //console.log("updated", data.name)
              }

            }
          }
        });
        this.socketService.on('newAlert').subscribe((data: any)=>{
          this.assetsService.getSingleAsset({query :{ '_id': data.asset._id}}).subscribe((data1)=>{
            if(data1){

              let notifAsset = data1.result[0];
              if(notifAsset && notifAsset.name && notifAsset.name !== ''){
                let message = 'New Alert from '+ notifAsset.name;
                if(this.backgroundMode.isActive()){
                  this.localNotifications.schedule({
                    id: data._id,
                    text: message
                  });
                }else{
                  this.presentToast(message);
                }
              }



            }
          })


        })
      })
    });
  }


  loadFleets(){
    this.fleetService.getFleetList({
      query: {
        _company_owner: this.selectedCompany._id
      },
      options: {
        populate: [{
          path: '_assets',
          select: '_id'
        }
        ]
      }
    }, 1000, 1).subscribe((data)=>{
      this.fleets = data.result;
      this.selectedFleet = this.fleets[0];
      this.loadAssets()
    })
  }

  loadAssets(){
    this.ids = [];
    if(this.selectedFleet){
      for(let asset of this.selectedFleet._assets){
        this.ids.push(asset._id)
      }
    }else{
      this.assets =[];
    }

    this.driversService.getDrivers({assetIds:this.ids}, 1000, 1).subscribe(data => {
      if(data && data.success && data.result.length>0){
        this.assets = data.result;
        this.assets = this.assetsService.getAssetsIcons(this.assets);
        this.loadAddress();
      }
    })
  }

  selectAll(){
    this.navCtrl.push(RealtimeMultiPage, {assets : this.assets});
  }
  selectOne(asset){
    this.navCtrl.push(MainPage, {asset: asset, canGoBack: true})
  }

  logout(){
    this.authService.disconnect().then(()=>{
      this.navCtrl.setRoot(LoginPage);
    })
  }

  setting(){
    let alert = this.alertCtrl.create({
      title: 'Mot de passe de l\'appareil',
    });

    this.storage.get('deviceParams').then((deviceParams)=>{
      alert.addInput({
        name: 'deviceUsername',
        placeholder: 'Username',
        type: 'string',
        value: deviceParams.username
      })
      alert.addInput({
        name: 'devicePassword',
        placeholder: 'Password',
        type: 'password',
        value: deviceParams.password
      })
       alert.addButton( {
         text: 'Valider',
         handler: data => {
           this.storage.set('deviceParams', {username: data.deviceUsername, password : data.devicePassword})
         }
       })
       alert.addButton( {
         text: 'Annuler',
         role: 'cancel',
         handler: data => {
           console.log('Cancel clicked');
         }
       })

    });

    alert.present();
  }

}


// WEBPACK FOOTER //
// ./src/pages/assets/assets.ts